"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSetCookie = void 0;
const getAllowedConsentGroups_1 = require("./getAllowedConsentGroups");
const canSetCookie = (cookie, key, categoryMap) => {
    const cookieCategory = categoryMap[key];
    /**
     * Strictly necessary cookies are always allowed. Edge Case: Uncategorized cookies (no mapping)
     * are allowed by default.
     */
    if (cookieCategory === 'C0001' || !cookieCategory) {
        return true;
    }
    const allowedConsentGroups = (0, getAllowedConsentGroups_1.getAllowedConsentGroups)(cookie);
    /**
     * Edge Case: That can happend only on the server side. If the consent cookie is missing, the
     * user hasn't seen consent banner yet. In this case, we should block cookies.
     */
    if (!allowedConsentGroups) {
        return false;
    }
    return allowedConsentGroups[cookieCategory];
};
exports.canSetCookie = canSetCookie;
//# sourceMappingURL=canSetCookie.js.map